import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";

const HowFitifyWorksSection = () => {
  const steps = [
    {
      step: "Step 1",
      title: "Sign Up & Set Your Goals",
      description:
        "Getting started with Fitify is simple. Begin by setting up your profile and telling us about your lifestyle, eating preferences, fitness habits, and health objectives. Whether your focus is weight loss, muscle gain, or improving energy and wellness, Fitify tailors the journey to your personal needs. From the very first step, you’ll know this isn’t a one size fits all solution it’s a path made for you.",
      icon: "📋", // Clipboard with chart icon representation
    },
    {
      step: "Step 2",
      title: "Get Your Personalized Plan",
      description:
        "Once your goals are set, Fitify designs a complete health strategy for you. You’ll receive custom meal plans with balanced nutrition, curated recipe suggestions, and smart daily reminders. Your workouts and diet adapt as you progress, ensuring flexibility without losing structure. No generic programs every plan is shaped to fit your lifestyle and long term results.",
      icon: "⚙️", // Person with gear icon representation
    },
    {
      step: "Step 3",
      title: "Track & Stay Consistent",
      description:
        "Consistency is key to transformation. Fitify gives you intuitive tools to log your meals, hydration, workouts, and even sleep patterns. Visual progress reports and habit streaks keep you motivated and accountable. With reminders and insights at every step, you’ll never feel lost you’ll always know exactly where you are on your journey.",
      icon: "⏳", // Hourglass icon representation
    },
    {
      step: "Step 4",
      title: "Celebrate Results",
      description:
        "Your hard work pays off, and Fitify makes sure you see it. From improved energy and physical progress to boosted confidence and healthier habits, every milestone is tracked and celebrated. Instead of quick fixes, you’ll enjoy real, sustainable changes that last a lifetime and a healthier, more confident version of yourself.",
      icon: "🚀", // Rocket with stars icon representation
    },
  ];

  return (
    <Container maxWidth="xl" sx={{ py: 8, position: "relative", zIndex: 2 }}>
      {/* Section Header */}
      <Box sx={{ textAlign: "center", mb: 8 }}>
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "2rem", md: "2.5rem", lg: "3rem" },
            fontWeight: 700,
            fontFamily: "Outfit",
            color: "#4ef4ff",
            mb: 3,
            lineHeight: 1.2,
          }}
        >
          How Fitify Works
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: "1rem", md: "1.2rem" },
            fontWeight: 400,
            fontFamily: "Outfit",
            color: "#FFFFFF",
            lineHeight: 1.6,
            maxWidth: "600px",
            margin: "0 auto",
          }}
        >
          Your personalized path to better health simple steps, lasting results.
        </Typography>
      </Box>

      {/* Steps Grid */}
      <Grid container spacing={{ xs: 4, md: 6 }}>
        {steps.map((step, index) => (
          <Grid item xs={12} md={6} lg={3} key={index}>
            <Box
              sx={{
                backgroundColor: "#242424",
                borderRadius: "20px",
                padding: { xs: "32px 24px", md: "40px 32px" },
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0 20px 40px rgba(78, 244, 255, 0.1)",
                },
              }}
            >
              {/* Icon */}
              <Box
                sx={{
                  width: "64px",
                  height: "64px",
                  backgroundColor: "#4ef4ff",
                  borderRadius: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 3,
                  fontSize: "28px",
                }}
              >
                {step.icon}
              </Box>

              {/* Step Number */}
              <Typography
                sx={{
                  fontSize: { xs: "1.1rem", md: "2rem" },
                  fontWeight: 700,
                  fontFamily: "Outfit",
                  color: "#FFFFFF",
                  mb: 1,
                }}
              >
                {step.step}
              </Typography>

              {/* Title */}
              <Typography
                sx={{
                  fontSize: { xs: "1.2rem", md: "1rem" },
                  fontWeight: 700,
                  fontFamily: "Outfit",
                  color: "#FFFFFF",
                  mb: 3,
                  lineHeight: 1.3,
                }}
              >
                {step.title}
              </Typography>

              {/* Description */}
              <Typography
                sx={{
                  fontSize: { xs: "0.95rem", md: "1rem" },
                  fontWeight: 400,
                  fontFamily: "Outfit",
                  color: "rgba(255, 255, 255, 0.8)",
                  lineHeight: 1.6,
                  flex: 1,
                }}
              >
                {step.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default HowFitifyWorksSection;
